import React from "react";
import FontAwesomeIcon from "./FontAwesomeIcon";

const CaretLeftIcon = (p) => <FontAwesomeIcon icon_id={"\uf0d9"} {...p} />;
const CaretRightIcon = (p) => <FontAwesomeIcon icon_id={"\uf0da"} {...p} />;
const CaretDownIcon = (p) => <FontAwesomeIcon icon_id={"\uf0d7"} {...p} />;
const CaretUpIcon = (p) => <FontAwesomeIcon icon_id={"\uf0d8"} {...p} />;
const CheckIcon = (p) => <FontAwesomeIcon icon_id={"\uf00c"} {...p} />;
const MailIcon = (p) => <FontAwesomeIcon icon_id={"\uf0e0"} {...p} />;
const WindowsIcon = (p) => <FontAwesomeIcon icon_id={"\uf17a"} {...p} />;
const AppleIcon = (p) => <FontAwesomeIcon icon_id={"\uf179"} {...p} />;
const MapIcon = (p) => <FontAwesomeIcon icon_id={"\uf279"} {...p} />;
const PhoneIcon = (p) => <FontAwesomeIcon icon_id={"\uf095"} {...p} />;
const SendIcon = (p) => <FontAwesomeIcon icon_id={"\uf1d8"} {...p} />;
const WarningIcon = (p) => <FontAwesomeIcon icon_id={"\uf071"} {...p} />;
const ChevronDown = (p) => <FontAwesomeIcon icon_id={"\uf078"} {...p} />;
const ChevronRight = (p) => <FontAwesomeIcon icon_id={"\uf054"} {...p} />;
const House = (p) => <FontAwesomeIcon icon_id={"\uf015"} {...p} />;
const MagnifyingGlass = (p) => <FontAwesomeIcon icon_id={"\uf002"} {...p} />;
const Check = (p) => <FontAwesomeIcon icon_id={"\uf00c"} {...p} />;
const FileExport = (p) => <FontAwesomeIcon icon_id={"\uf56e"} {...p} />;
const Spinner = (p) => <FontAwesomeIcon icon_id={"\uf110"} {...p} />;
const Copy = (p) => <FontAwesomeIcon icon_id={"\uf0c5"} {...p} />;
const Pdf = (p) => <FontAwesomeIcon icon_id={"\uf1c1"} {...p} />;
const CheckCircle = (p) => <FontAwesomeIcon icon_id={"\uf058"} {...p} />;
const FileDownload = (p) => <FontAwesomeIcon icon_id={"\uf56d"} {...p} />;
const XmarkCircle = (p) => <FontAwesomeIcon icon_id={"\uf057"} {...p} />;

export {
  XmarkCircle,
  FileDownload,
  CheckCircle,
  Pdf,
  Spinner,
  WarningIcon,
  WindowsIcon,
  AppleIcon,
  CheckIcon,
  MapIcon,
  PhoneIcon,
  MailIcon,
  SendIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretDownIcon,
  CaretUpIcon,
  Check,
  House,
  MagnifyingGlass,
  ChevronDown,
  ChevronRight,
  FileExport,
  Copy
};
